<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202308_01.jpg">
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>マナビス化粧品が提案する</span><br>丁寧な洗顔</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">知ってほしい、大切なのは「朝晩の洗顔」</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-60">
        <img src="@/assets/img/column/202308_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-40">
        <h3 class="mb-3">毎日の洗顔は、美肌への近道</h3>
        <p class="mb-3">毎日の習慣である「洗顔」。</p>
        <p class="mb-3">日常である洗顔は、美肌にとって重要なスキンケアタイムであることをご存知でしょうか？</p>
        <p class="mb-3">お肌を清潔にするだけでなく、化粧水や美容液などスペシャルケアの受け入れ態勢を整える浸透を高める、とても大切なステップ。</p>
        <p class="mb-3">当たり前なのに毎日のことなので、ささっと済ませてしまう方も多いのではないでしょうか。</p>
        <p>実際に、美容液や化粧品などはリッチなアイテムを取り揃える一方で、洗顔料をあまり気にかけたことがないというお声をよく耳にします。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">重要さを忘れがち？<br>洗顔はスキンケアのファーストステップ</h3>
        <p class="mb-3">お肌にトラブルがあった時、まずは見直すべきとも言われる「洗顔」。</p>
        <p class="mb-3">洗顔はスキンケアの入口であり、ファーストステップです。</p>
        <p class="mb-3">そして重要なポイントのひとつは「洗顔の順番」。</p>
        <p class="mb-3">意外に正しい洗顔の仕方を意識せず、無意識に洗ってしまっている方も多いかもしれません。</p>
        <p>基本だからこそ大切にすべきは「朝晩の丁寧な洗顔」なのです。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202308_03.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202308_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">洗顔が大切な理由</h3>
        <p class="mb-3">理由はとてもシンプル。</p>
        <p class="mb-3">お肌を健やかに保ち、スキンケアの受け入れ態勢を整えるため。</p>
        <p class="mb-3">花粉などの汚れや余分な皮脂を落とし素肌を清潔に保つことで、お肌は正常な<strong>「ターンーオーバー」</strong>を行うことができ、同時に化粧水など<strong>ネクストケアの吸収を受け入れる態勢</strong>を整えます。</p>
        <p>毎日の洗顔に対する意識が変われば、それだけ美肌に近づけるチャンスです。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3"><small>知ってほしいのはこの3つ</small></p>
        <p class="mb-3 fs-2">「朝晩の洗顔」「上質泡」「保湿」</p>
        <p class="mb-5">簡単だけど丁寧なルーティンケアの積み重ね。</p>
        <p class="mb-3">朝と夜の「洗顔」タイムで</p>
        <p class="mb-3">素肌をもっちり「上質な泡」で優しく包み込み</p>
        <p class="mb-5">無垢で清潔な状態のお肌をしっかりと「保湿」する。</p>
        <p>女性も男性も年齢に関係なく<br>毎日できる大切なスキンケアは「洗顔」なのです。</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5">毎日のことだから伝えたい。<br>「丁寧な洗顔」をマナビス化粧品は推奨します。</h2>

    <h2 class="pt-5">正しい洗顔のステップ</h2>

    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202308_05.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3"><small>STEP1</small><br>洗顔料を泡だてる</h3>
        <p class="mb-3">泡立て方も大切なポイント。手で泡立てることもいいですが、毎日の洗顔の中では、時短で細かい泡が作れる洗顔ネットや泡立て器がおすすめ。</p>
        <p class="mb-3">今回はマナビスバブルフォーマー（泡立て器）を使った、泡立て方をご紹介。</p>
        <p class="mb-3">チューブタイプであればテクスチャーを2cm程度を出し、30～40℃のぬるま湯でしっかり泡立てます。</p>
        <p class="mb-3">手で泡立てるコツは、空気を入れるように素早く細かく動かすこと。</p>
        <p>泡立て器や洗顔用の泡立てネットをお使いいただくと、手早く濃密な泡を作ることができます。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202308_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3"><small>STEP2</small><br>泡で包み込むように洗う</h3>
        <p class="mb-3">泡立てた弾力のある泡でお顔を包み込むように、やさしく洗います。</p>
        <p class="mb-3">皮脂の多いTゾーン（おでこ・鼻筋・小鼻）から洗い始めるのがおすすめの洗顔の順番。</p>
        <p class="mb-3">次に面積の広いUゾーン（頬・顎）。</p>
        <p class="mb-3">最後に皮膚の薄い目元・口元は特にやさしく、泡をサッとなじませます。</p>
        <p class="mb-3">それぞれ指でやさしく、クルクルと円を描くように洗いましょう。一カ所、 20秒ほどが目安です。</p>
        <p>このような洗顔の順番で洗うことで泡が乗っている部分に時間差が生まれ、洗顔摩擦のダメージを抑えることが出来ます。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202308_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3"><small>STEP3</small><br>インバスケアでしっかりと保湿</h3>
        <p class="mb-3">やさしく泡を洗い流した後は潤いを逃さないようにスピーディーにしっかりと保湿を。</p>
        <p class="mb-3">特にバスタイム後のお肌の保湿はスピードが重要。</p>
        <p class="mb-3">一般的にはスペシャルケアとされているパックを、お風呂の中で使用し洗顔後の肌の保湿を行う、最近注目されているキーワードの「インバスケア」。</p>
        <p class="mb-3">入浴するとお肌に水分が浸透して角層が膨らみ、一時的にうるおった状態になりますが、実はお湯で皮脂などの保湿成分が流れ出た肌は、水分を保つことができません。</p>
        <p class="mb-3">お風呂上りは10分も経つと、入浴前以上にうるおいが奪われてしまい"過乾燥肌"に陥ってしまうことも…。</p>
        <p class="mb-3">マナビス化粧品はそこに着目。</p>
        <p>1秒でもお肌が乾燥状態にならないようインバスケアを提案しています。</p>
      </div>
    </div>

    <h2 class="pt-5">マナビス化粧品のおすすめ洗顔アイテム</h2>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinwash_set_202308.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンウォッシュ チューブタイプ＋ マナビスバブルフォーマー（泡立て器）2点セット</h3>
        <p class="mb-3">¥6,000</p>
        <p class="mb-3">待望の2点セットでの販売開始です。</p>
        <p>「マナビスバブルフォーマー（泡立て器）」をご使用いただくことで、洗顔料「薬用スキンウォッシュ」の泡立ちを良くし、よりきめの細かい弾力のある泡を作ることができます。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンウォッシュd<br>薬用スキンウォッシュ チューブタイプ</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">毎朝晩の洗顔に。</p>
        <p class="mb-3">うるおいはそのままに、やわらかな泡で包むように洗う。</p>
        <p>17種類の植物由来成分配合のアミノ酸系弱酸性ジェル状せっけん。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinwashd_skinwashtube_202308.jpg">
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinmask_skinmasktube_202308.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンマスク<br>薬用スキンマスク チューブタイプ</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">インバスケアで保湿革命。</p>
        <p class="mb-3">洗いたての素肌を包み、<br>うるおし、なめらかにするパック。</p>
        <p>洗い流せる、やわらかなクリーム状のテクスチャーでお風呂でも使えるアイテムです。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>薬用エモリエントローション EX</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">洗顔後の素肌を、より、みずみずしく。</p>
        <p class="mb-3">細かな霧がお肌に心地よくなじみ、キメを整えます。</p>
        <p>使いやすいミストタイプの化粧水。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_lotion_202308.jpg">
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_restorejelset_202308.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">BASIC<br>薬用レストアジェル EXc</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">軽いつけ心地なのに、しっとり。</p>
        <p class="mb-3">水分と油分をバランスよく与える乳液。</p>
        <p>美白有効成分トラネキサム酸も配合。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>薬用リンクルジェル</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">コクがあるのにベタつかない。</p>
        <p class="mb-3">なめらかなベールで包みこむように、うるおいを閉じこめるクリーム。</p>
        <p>お肌の整肌を助ける、グリチルレチン酸配合。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_wrinklegel_202308.jpg">
      </div>
    </div>

  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 600px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}
.layer_02 {
  position: relative;
  display: flex;
  align-items: center;
  background-image: url('../../assets/img/column/202309_06.jpg');
  background-size: cover;
  min-height: 750px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 60px; /* テキストと画像の端の間に余白を設定 */
  background-position: center;
}
.layer_02 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_02 .layer-text .layer-text-inner h2 {
  font-size: 2.5em;
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer_02 {
    min-height: 300px;
    padding: 15px;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>